<template>
  <div class="contact-request">
    <div class="contact-request-header">
      <div class="contact-request-close">
        <div class="button-text">Fechar</div>
        <button @click="contactClose"><div class="icon-close"></div></button>
      </div>
      <h2>Editar dados</h2>
    </div>
    <hr>
    <div class="contact-request-body">
      <h2>Telefone</h2>
      <div class="input-wrapper" v-for="phone in phones" v-bind:key="'A-' + phone.id">
        <label v-if="phone.defaultPhoneNumber">
          Telefone principal
        </label>
        <div>
          <div :class="phone.defaultPhoneNumber && !phone.disabled ? 'animate__animated animate__fadeIn data-label' : 'data-label'" v-if="phone.defaultPhoneNumber && !phone.disabled">{{ phone.phoneNumber | phone-format }}</div>
          <span class="icon-star checked" v-if="phone.defaultPhoneNumber && !phone.disabled"></span>
          <span class="loading-text" v-if="phone.defaultPhoneNumber && !phone.disabled && loadingPhone">Carregando...</span>
        </div>
      </div>
      <div class="input-wrapper" v-for="(phone, index) in phones" v-bind:key="'B-' + phone.id">
        <label v-if="index === 0 && !phone.disabled">
          Outros
        </label>
        <div v-if="!phone.disabled && !loadingPhone">
          <div :class="phone.last ? 'animate__animated animate__fadeIn data-label' : 'data-label'" v-if="!phone.defaultPhoneNumber">{{ phone.phoneNumber | phone-format }}</div>
          <span class="icon-star unchecked" v-if="!phone.defaultPhoneNumber" @click="makeDefaultPhone(phone.id)"></span>
          <a v-if="!phone.defaultPhoneNumber" @click="makeDisabledPhone(phone.id)">Desativar</a>
        </div>
      </div>
      <div class="input-wrapper">
        <div style="margin-top: 10px;" v-if="showInputNewPhoneNumber">
          <input placeholder="(00) 0 0000-0000" v-mask="['(##) # ####-####']" v-model="newPhone" @keypress.enter="addPhone" />
          <span :class="newPhone && newPhone.length === 16 ? 'micon-check check-default' : 'micon-check check-default-new'"  @click="addPhone"></span>
        </div>
      </div>
      <span>
        <button @click="showInputNewPhoneNumber = !showInputNewPhoneNumber">
          {{showInputNewPhoneNumber ? 'Cancelar' : 'Novo número'}}
        </button>
        <span></span>
      </span>
      <div class="input-wrapper" v-for="(phone, index) in phones" v-bind:key="'C-' + phone.id">
        <label v-if="index === 0 && phone.disabled">
          Desativados
        </label>
        <div v-if="phone.disabled">
          <div class="data-label">{{ phone.phoneNumber | phone-format }}</div>
          <a @click="makeActivatedPhone(phone.id)">Reativar número</a>
        </div>
      </div>
    </div>

    <!-- EMAIL -->
    <hr>
    <div class="contact-request-body">
      <h2>Email</h2>
      <div class="input-wrapper" v-for="email in emails" v-bind:key="'D-' + email.id">
        <label v-if="email.defaultEmail">
          Email principal
        </label>
        <div>
          <div :class="email.defaultEmail && !email.disabled ? 'animate__animated animate__fadeIn data-label' : 'data-label'" v-if="email.defaultEmail && !email.disabled">{{ email.email }}</div>
          <span class="icon-star checked" v-if="email.defaultEmail && !email.disabled"></span>
          <span class="loading-text" v-if="email.defaultEmail && !email.disabled && loadingEmail">Carregando...</span>
        </div>
      </div>
      <div class="input-wrapper" v-for="(email, index) in emails" v-bind:key="'E-' + email.id">
        <label v-if="index === 0 && !email.disabled">
          Outros
        </label>
        <div v-if="!email.disabled && !loadingEmail">
          <div :class="email.last ? 'animate__animated animate__fadeIn data-label' : 'data-label'" v-if="!email.defaultEmail">{{ email.email }}</div>
          <span class="icon-star unchecked" v-if="!email.defaultEmail" @click="makeDefaultEmail(email.id)"></span>
          <a v-if="!email.defaultEmail" @click="makeDisabledEmail(email.id)">Desativar</a>
        </div>
      </div>
      <div class="input-wrapper" v-if="showInputNewEmail">
        <div style="margin-top: 10px;">
          <input placeholder="exemplo@email.com" v-model="newEmail" type="email" @keydown="validateEmail($event)"/>
          <span :class="emailValidated ? 'micon-check check-default' : 'micon-check check-default-new'" @click="addEmail"></span>
        </div>
      </div>
      <span>
        <button @click="showInputNewEmail = !showInputNewEmail">
          {{showInputNewEmail ? "Cancelar" : "Novo email"}}
        </button>
        <span></span>
      </span>
      <div class="input-wrapper" v-for="(email, index) in emails" v-bind:key="'F-' + email.id">
        <label v-if="index === 0 && email.disabled">
          Desativados
        </label>
        <div v-if="email.disabled">
          <div class="data-label">{{ email.email }}</div>
          <a @click="makeActivatedEmail(email.id)">Reativar email</a>
        </div>
      </div>
      <!-- <hr>
      <span>
        <span></span>
        <button @click="addEmail">
          <div class="spinner-border spinner-border-sm" role="status" v-if="loading">
            <span class="sr-only">Loading...</span>
          </div>
          Salvar
        </button>
      </span> -->
    </div>
  </div>
</template>

<script>
import Input from '../form/Input.vue'
export default {
  components: { Input },
  data () {
    return {
      loadingEmail: false,
      loadingPhone: false,
      phones: [],
      newPhone: '',
      showInputNewPhoneNumber: false,
      lastPhoneNumber: {},
      emails: [],
      newEmail: '',
      showInputNewEmail: false,
      lastEmail: {},
      emailValidated: false

    }
  },
  mounted () {
    this.loadPhones()
    this.loadEmails()
  },
  methods: {
    validateEmail (e) {
      let reg = /\S+@\S+\.\S+/
      this.emailValidated = reg.test(e.target.value)
    },
    contactClose () {
      this.$emit('emitContactClose')
    },
    loadPhones () {
      this.$root.$emit('loadphone')
      this.$http.get('api/validations/' + this.$route.params.txid + '/phones')
        .then(function (res) {
          this.phones = []

          res.data.list.forEach(phone => {
            if (this.lastPhoneNumber) {
              if (this.lastPhoneNumber.id !== phone.id) {
                this.phones.push({
                  id: phone.id,
                  phoneNumber: phone.phoneNumber,
                  confirmed: phone.confirmed,
                  source: phone.source,
                  defaultPhoneNumber: phone.defaultPhoneNumber,
                  disabled: phone.disabled,
                  last: false
                })
              } else {
                this.phones.push({
                  id: this.lastPhoneNumber.id,
                  phoneNumber: this.lastPhoneNumber.phoneNumber,
                  confirmed: this.lastPhoneNumber.confirmed,
                  source: this.lastPhoneNumber.source,
                  defaultPhoneNumber: false,
                  disabled: this.lastPhoneNumber.disabled,
                  last: true
                })
              }
            } else {
              this.phones.push({
                id: phone.id,
                phoneNumber: phone.phoneNumber,
                confirmed: phone.confirmed,
                source: phone.source,
                defaultPhoneNumber: phone.defaultPhoneNumber,
                disabled: phone.disabled,
                last: false
              })
            }
          })

          this.phones = this.phones.sort(function (a, b) {
            return (a.last === b.last) ? 0 : a.last ? 1 : -1
          })

          this.lastPhoneNumber = {}
          this.loadingPhone = false
        })
        .catch(function (res) {
          console.error(res)
        })
    },
    addPhone () {
      this.newPhone = this.newPhone.replace(/([^\d])+/gim, '')
      if (this.newPhone.length < 11) {
        return
      }
      this.loadingPhone = true
      this.$http.post('api/validations/' + this.$route.params.txid + '/phones', {phoneNumber: this.newPhone})
        .then(function (res) {
          this.newPhone = ''
          this.loadPhones()
          this.$emit('emit-update-customer-data', true)
        })
        .catch(function (res) {
          console.error(res)
          this.$bvToast.toast(`${this.newPhone} ${res.data}`, {
            title: 'Erro ao adicionar',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    makeDefaultPhone (id) {
      this.loadingPhone = true
      this.lastPhoneNumber = this.phones.find(phone => {
        return phone.defaultPhoneNumber && !phone.disabled
      })

      this.$http.post('api/validations/' + this.$route.params.txid + '/phones/' + id)
        .then(function (res) {
          this.loadPhones()
          this.$emit('emit-update-customer-data', true)
        })
        .catch(function (res) {
          console.error(res)
          this.$bvToast.toast(`${res.data}`, {
            title: 'Erro ao marcar como padrão',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    makeDisabledPhone (id) {
      this.loadingPhone = true
      this.$http.post('api/validations/' + this.$route.params.txid + '/phones/' + id + '/disable')
        .then(function (res) {
          this.loadPhones()
          this.$emit('emit-update-customer-data', true)
        })
        .catch(function (res) {
          console.error(res)
          this.$bvToast.toast(`${res.data}`, {
            title: 'Erro ao desabilitar telefone',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    makeActivatedPhone (id) {
      this.loadingPhone = true
      this.$http.post('api/validations/' + this.$route.params.txid + '/phones/' + id + '/activate')
        .then(function (res) {
          this.loadPhones()
          this.$emit('emit-update-customer-data', true)
        })
        .catch(function (res) {
          console.error(res)
          this.$bvToast.toast(`${res.data}`, {
            title: 'Erro ao ativar telefone',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    // EMAIL
    loadEmails () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/emails')
        .then(function (res) {
          // this.emails = res.data.list
          // this.emails = this.emails.sort(function (a, b) {
          //   return (a.defaultEmail === b.defaultEmail) ? 0 : a.defaultEmail ? -1 : 1
          // })

          this.emails = []

          res.data.list.forEach(email => {
            if (this.lastEmail) {
              if (this.lastEmail.id !== email.id) {
                this.emails.push({
                  id: email.id,
                  email: email.email,
                  confirmed: email.confirmed,
                  source: email.source,
                  defaultEmail: email.defaultEmail,
                  disabled: email.disabled,
                  last: false
                })
              } else {
                this.emails.push({
                  id: this.lastEmail.id,
                  email: this.lastEmail.email,
                  confirmed: this.lastEmail.confirmed,
                  source: this.lastEmail.source,
                  defaultEmail: false,
                  disabled: this.lastEmail.disabled,
                  last: true
                })
              }
            } else {
              this.emails.push({
                id: email.id,
                email: email.email,
                confirmed: email.confirmed,
                source: email.source,
                defaultEmail: email.defaultEmail,
                disabled: email.disabled,
                last: false
              })
            }
          })

          this.emails = this.emails.sort(function (a, b) {
            return (a.last === b.last) ? 0 : a.last ? 1 : -1
          })

          this.lastEmail = {}
          this.loadingEmail = false
        })
        .catch(function (res) {
          console.error(res)
        })
    },
    addEmail () {
      if (!this.emailValidated) {
        return
      }
      this.loadingEmail = true
      this.$http.post('api/validations/' + this.$route.params.txid + '/emails', {email: this.newEmail})
        .then(function (res) {
          this.newEmail = ''
          this.emailValidated = false
          this.loadEmails()
          this.$emit('emit-update-customer-data', true)
        })
        .catch(function (res) {
          console.error(res)
          this.$bvToast.toast(`${this.newEmail} ${res.data}`, {
            title: 'Erro ao adicionar',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    makeDefaultEmail (id) {
      this.lastEmail = this.emails.find(email => {
        return email.defaultEmail && !email.disabled
      })
      this.loadingEmail = true
      this.$http.post('api/validations/' + this.$route.params.txid + '/emails/' + id)
        .then(function (res) {
          this.loadEmails()
          this.$emit('emit-update-customer-data', true)
        })
        .catch(function (res) {
          console.error(res)
          this.$bvToast.toast(`${res.data}`, {
            title: 'Erro ao marcar como padrão',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    makeDisabledEmail (id) {
      this.loadingEmail = true
      this.$http.post('api/validations/' + this.$route.params.txid + '/emails/' + id + '/disable')
        .then(function (res) {
          this.loadEmails()
          this.$emit('emit-update-customer-data', true)
        })
        .catch(function (res) {
          console.error(res)
          this.$bvToast.toast(`${res.data}`, {
            title: 'Erro ao desabilitar email',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    makeActivatedEmail (id) {
      this.loadingEmail = true
      this.$http.post('api/validations/' + this.$route.params.txid + '/emails/' + id + '/activate')
        .then(function (res) {
          this.loadEmails()
          this.$emit('emit-update-customer-data', true)
        })
        .catch(function (res) {
          console.error(res)
          this.$bvToast.toast(`${res.data}`, {
            title: 'Erro ao ativar email',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    }
  },
  props: []
}
</script>

<style lang="scss" scoped>
.contact-request {
  width: calc(30% - 20px);
  border-radius: 16px;
  margin-left: 20px;
  float: right;
  background-color: #FFFFFF;
  .contact-request-header {
    padding: 16px;
    .contact-request-close {
      display: flex;
      justify-content: flex-end;
      button {
        width: 24px;
        height: 24px;
        float: right;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-top: -4px;
        padding: 0px;
        border: none;
        background: rgba(66, 133, 244, 0.2);
        color: #4285F4;
        outline: none;
      }
      .button-text {
        float: right;
        line-height: 1.4em;
        color: rgba(66, 133, 244, 0.75);
        margin-right: 4px;
      }
    }
  }
  h2 {
    margin: 0;
    font-size: 16px;
    color: #666666;
    &.space {
      margin-bottom: 32px;
    }
  }
  .contact-request-body {
    padding: 24px;
    h2 {
      margin: 0;
      font-size: 16px;
      color: #666666;
      margin-bottom: 32px;
    }
    .input-wrapper {
      display: flex;
      flex-direction: column;

      .loading-text {
        font-size: 12px;
        color: #666666;
        display: flex;
        align-items: center;
        float: left;
      }

      div {
        display: flex;
        align-items: center;

        span {
          margin-left: 5px;
          font-size: 20px;
          margin-bottom: 20px;
          cursor: pointer;
        }

        .checked {
          color: orange;
        }

        .unchecked {
          color: #CCC;
        }

        .check-default {
          color: #41BD64;
        }

        .check-default-new {
          color: #CCC;
        }

        .data-label {
          width: 50%;
          min-height: 45px;
          margin-bottom: 20px;
          padding: 16px;
          border: none;
          background-color: #F3F3F3;
          word-break: break-all;
          border: 1px solid #F3F3F3;
        }

        .data-label-last-choise {
          border-color: #4285F4;
        }

        a {
          margin-left: 5px;
          margin-bottom: 17px;
          color: #4285F4;
          cursor: pointer;
        }
      }

      label {
        font-size: 12px;
        color: #666666;
        display: flex;
        align-items: center;
        float: left;
      }
      input {
        width: 50%;
        min-height: 45px;
        margin-bottom: 20px;
        padding: 16px;
        border: none;
        background-color: #F3F3F3;
      }
    }
    select {
      width: 100%;
      height: 40px;
      border: none;
      margin-bottom: 36px;
      background-color: #f3f3f3;
    }
    span {
      display: flex;
      align-items: center;
      justify-content: space-between;
      label {
        margin: 0;
      }
      button {
        width: 100px;
        height: 32px;
        border-radius: 5px;
        border: none;
        float: left;
        background-color: #1c56e0;
        color: #ffffff;
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/ContactRequest.vue